<template>
    <div class="container-fluid bg-white border rounded-3 p-4">
        <h2>Doctor Orders</h2>
        <hr />

        <div v-if="loading" class="text-center my-4">
            <div class="spinner-border text-primary" role="status"></div>
        </div>

        <div v-else-if="errorMessage" class="alert alert-danger">
            {{ errorMessage }}
        </div>

        <div v-else>
            <table class="table table-bordered table-striped w-100">
                <thead class="table-light">
                    <tr>
                        <th>Client Name</th>
                        <th>Client PID</th>
                        <th>Date</th>
                        <!-- <th>Reason for Visit</th> -->
                        <th>Signature Date</th>

                        <!-- <th>Updated on</th> -->
                        <th>Actions</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="order in doctorOrders" :key="order.id">
                        <td>{{ order.student?.user?.name || '-' }}</td>
                        <td>{{ order.student?.pid || '-' }}</td>
                        <td>{{ $formatDate(order.date) }}</td>
                        <!-- <td>
                            <ul class="mb-0">
                                <li v-for="reason in parseReasons(order.reason)" :key="reason.id">
                                    {{ reason.title }}
                                </li>
                            </ul>
                        </td> -->
                        <td>{{ $formatDate(order.signed_at) || '—' }}</td>
                        <td>
                            <button class="btn btn-sm btn-primary"
                                @click="$router.push({ name: 'PractitionerSignature', params: { id: order.id } })">
                                ✍️ Sign
                            </button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            doctorOrders: [],
            loading: true,
            errorMessage: '',
        };
    },
    mounted() {
        this.fetchDoctorOrders();
    },
    methods: {
        async fetchDoctorOrders() {
            try {
                const response = await this.$api.get('/doctor-orders');
                this.doctorOrders = response.data;
            } catch (error) {
                this.errorMessage = error.response?.data?.message || 'Failed to load doctor orders.';
            } finally {
                this.loading = false;
            }
        },
        parseReasons(reasonJson) {
            try {
                return JSON.parse(reasonJson);
            } catch {
                return [];
            }
        }
    }
};
</script>
